<template>
	<PayUnlockShell v-bind="shellProps" stack-action @select="$emit('select')">
		<template #left>
			<PayIcon icon="creator" color="#fff" :bg="btnColor" :h5="h5" />
		</template>
		<template #info>
			<p class="g-block-pay-unlock__desc">{{ data.title || '创作者专属' }}</p>
			<p class="g-block-pay-unlock__count" :style="priceColor">{{ data.subtitle || '优质内容 · 创作者分成' }}</p>
		</template>
		<template #action>
			<span class="g-block-pay-unlock__price g-block-pay-unlock__price--sm" :style="priceColor">¥ {{ displayPrice }}</span>
			<PayUnlockButton
				:text="data.buttonText || '立即解锁'"
				:style="buttonStyle"
				@click="onButtonClick"
			/>
		</template>
	</PayUnlockShell>
</template>

<script>
	import PayUnlockShell from '../shared/PayUnlockShell.vue';
	import PayUnlockButton from '../shared/PayUnlockButton.vue';
	import PayIcon from '../shared/PayIcon.vue';
	import { payUnlockMixin } from '../shared/mixin.js';
	import { formatPayPrice, getButtonColor } from '../shared/utils.js';
	import { DEFAULT_PAY_UNLOCK_CREATOR } from '../../../templates.js';

	export default {
		name: 'GBlockPayUnlockCreator',
		components: { PayUnlockShell, PayUnlockButton, PayIcon },
		mixins: [payUnlockMixin],
		computed: {
			defaultButtonColors() {
				return DEFAULT_PAY_UNLOCK_CREATOR;
			},
			btnColor() {
				return getButtonColor(this.data, DEFAULT_PAY_UNLOCK_CREATOR);
			},
			priceColor() {
				return { color: this.btnColor };
			},
			shellProps() {
				return {
					data: this.data,
					editable: this.editable,
					active: this.active,
					fixedBottom: this.fixedBottom,
					h5: this.h5,
					stackAction: true,
				};
			},
			displayPrice() {
				return formatPayPrice(this.data.price);
			},
		},
	};
</script>
